<p-confirmDialog acceptButtonStyleClass="p-button-danger" rejectButtonStyleClass="p-button-secondary p-button-outlined" />
@if (auth.isAuthenticated()) {
  <div class="app-shell">
    <app-sidebar />
    <div class="main-column">
      <app-shared-header />
      <app-error-banner />
      <app-workflow-notice-banner />
      <main class="page">
        <router-outlet />
      </main>
    </div>
  </div>
} @else {
  <app-error-banner />
  <main class="page">
    <router-outlet />
  </main>
}
